export default {

    init($vue) {
        $vue.$store.commit('onboarding/DISPLAY_ADMIN_WELCOME_WESTUDY_COURSES')
    }

}